import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const HELMET = "/eazybot-helmet.png";

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLiveClasses = (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      const el = document.getElementById("how-it-works");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById("how-it-works");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 350);
    }
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-40 transition-all duration-300"
      style={{
        background: scrolled
          ? "rgba(20,16,52,0.85)"
          : "transparent",
        backdropFilter: scrolled ? "blur(14px)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(14px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.08)" : "1px solid transparent",
      }}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-4 md:h-24 md:py-0 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3 md:gap-[6px]"
          data-testid="header-logo-link"
        >
          <img
            src={HELMET}
            alt="EazyBot"
            className="h-14 md:h-[90px] w-auto"
            style={{
              filter:
                "drop-shadow(0 0 14px rgba(3,172,239,0.55)) drop-shadow(0 2px 3px rgba(0,0,0,0.5))",
            }}
            data-testid="header-logo-image"
          />
          <span
            className="text-2xl md:text-[30px] leading-none font-display"
            style={{ color: "#fff", fontWeight: 700, letterSpacing: "-0.01em" }}
            data-testid="header-wordmark"
          >
            Ea<span style={{ color: "#03ACEF" }}>z</span>yBot
          </span>
        </Link>

        <div className="hidden sm:flex items-center gap-3">
          <a
            href="#how-it-works"
            onClick={handleLiveClasses}
            className="inline-flex items-center gap-2 px-4 md:px-5 py-2 md:py-2.5 text-xs md:text-sm font-semibold border border-white/25 text-white transition-colors rounded-full"
            style={{ background: "rgba(255,255,255,0.04)" }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#D4A24C";
              e.currentTarget.style.color = "#141034";
              e.currentTarget.style.borderColor = "#D4A24C";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.04)";
              e.currentTarget.style.color = "#fff";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.25)";
            }}
            data-testid="header-cta-live-classes"
          >
            Live Classes
            <span aria-hidden="true">↓</span>
          </a>
          <button
            type="button"
            onClick={() => navigate("/get-started")}
            className="inline-flex items-center gap-2 px-4 md:px-5 py-2 md:py-2.5 text-xs md:text-sm font-semibold rounded-full transition-colors"
            style={{
              background: "rgba(212,162,76,0.10)",
              border: "1.5px solid #D4A24C",
              color: "#F2C860",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(212,162,76,0.22)";
              e.currentTarget.style.borderColor = "#F2C860";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(212,162,76,0.10)";
              e.currentTarget.style.borderColor = "#D4A24C";
            }}
            data-testid="header-get-started"
          >
            Setup Guide
          </button>
        </div>
      </div>
    </header>
  );
};
